import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SectionItem } from 'projects/phdsoft/common/src/lib/models/sectionitem-info.model';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { SectionsCacheService } from './sections-cache.service';

@Injectable({
  providedIn: 'root'
})
export class SectionsService {

  constructor(
    private readonly http: HttpClient,
    private readonly sectionsCacheService: SectionsCacheService
  ) { }

  post(regions: SectionItem[], assetId: string){
    return this.http.post(
        environment.API_THREED + `Sections/AddMultiple/${assetId}`, regions
    )
  }

  getSections(assetId: string): Observable<SectionItem[]> {
    let sections$ = this.sectionsCacheService.getValue(assetId);

    if (!sections$) {
      sections$ = this.http.get<SectionItem[]>(
        environment.API_THREED + `Sections/GetSections/${assetId}`,
        ).pipe(
          shareReplay(1)
        );

      this.sectionsCacheService.setValue(sections$, assetId);
    }

    return sections$;
  }

  getSectionsFromMicroservice(assetId: string): Observable<SectionItem[]> {
    return this.http.get<SectionItem[]>(
      environment.API_THREED + `Sections/GetSections/${assetId}`);
  }

  getSection(sectionId: string): Observable<SectionItem> {
    return this.http.get<SectionItem>(
        environment.API_THREED + `Sections/${sectionId}`,
    ).pipe(
      shareReplay(1)
    )
  }

  clearCache(){
    this.sectionsCacheService.clearCache()
  }
}
